module.exports = __webpack_public_path__ + "static/media/mapRoller.af0901fb.jpg";